import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleCategorie from "@/pages/article/categorie";
import ArticleSicurezza from "@/pages/article/sicurezza";
import ArticleConfronto from "@/pages/article/confronto";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-guida-completa",
    element: <ArticlePage />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-categorie-prodotti",
    element: <ArticleCategorie />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-sicurezza-acquisti",
    element: <ArticleSicurezza />,
  },
  {
    path: "/articoli/itaobuy-spreadsheet-confronto-prezzi",
    element: <ArticleConfronto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;